export default{
  carousel:{
    lip6:{
      part1:[
        {
          id: 0,
          title: '',
          text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_2.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_3.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_4.jpg"
        },
        {
          id: 3,
          title: '',
          text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_5.jpg"
        },
        {
          id: 4,
          title: '',
          text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_6.jpg"
        },
        {
          id: 5,
          title: '',
          text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_7.jpg"
        },
        {
          id: 6,
          title: '',
          text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_8.jpg"
        },
        {
          id: 7,
          title: '',
          text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_9.jpg"
        },
        {
          id: 8,
          title: '',
          text: 'Uroczystości zainaugurowała Msza Św. w kościele pw. Św. Teresy',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_10.jpg"
        }
      ],
      part2:[
        {
          id: 0,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_11.jpg"
        },
        {
          id: 1,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_12.jpg"
        },
        {
          id: 2,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_13.jpg"
        },
        {
          id: 3,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_14.jpg"
        },
        {
          id: 4,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_15.jpg"
        },
        {
          id: 5,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_16.jpg"
        },
        {
          id: 6,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_17.jpg"
        },
        {
          id: 7,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_18.jpg"
        },
        {
          id: 8,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_19.jpg"
        },
        {
          id: 9,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_20.jpg"
        },
        {
          id: 10,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_21.jpg"
        },
        {
          id: 11,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_22.jpg"
        },
        {
          id: 12,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_23.jpg"
        },
        {
          id: 13,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_24.jpg"
        },
        {
          id: 14,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_25.jpg"
        },
        {
          id: 15,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_26.jpg"
        },
        {
          id: 16,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_27.jpg"
        },
        {
          id: 17,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_28.jpg"
        },
        {
          id: 18,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_29.jpg"
        },
        {
          id: 19,
          title: '',
          text: 'Główna ceremonia na cmentarzu „Na Rossie”',
          img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_30.jpg"
        }
      ],
    },
    lip7:[
      {
        id: 0,
        title: '',
        text: 'Uroczystości w podwileńskich Krawczunach',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_31.jpg"
      },
      {
        id: 1,
        title: '',
        text: 'Uroczystości w podwileńskich Krawczunach',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_34.jpg"
      },
      {
        id: 2,
        title: '',
        text: 'Uroczystości w podwileńskich Krawczunach',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_35.jpg"
      },
      {
        id: 3,
        title: '',
        text: 'Uroczystości w podwileńskich Krawczunach',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_36.jpg"
      },
      {
        id: 4,
        title: '',
        text: 'Uroczystości w podwileńskich Krawczunach',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_37.jpg"
      },
      {
        id: 5,
        title: '',
        text: 'Uroczystości w podwileńskich Krawczunach',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_38.jpg"
      },
      {
        id: 6,
        title: '',
        text: 'Uroczystości w Kalwarii Wileńskiej',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_42.jpg"
      },
      {
        id: 7,
        title: '',
        text: 'Uroczystości w Kalwarii Wileńskiej',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_43.jpg"
      },
      {
        id: 8,
        title: '',
        text: 'Uroczystości w Kalwarii Wileńskiej',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_44.jpg"
      },
      {
        id: 9,
        title: '',
        text: 'Uroczystości w Kalwarii Wileńskiej',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_45.jpg"
      },
      {
        id: 10,
        title: '',
        text: 'Uroczystości w Kalwarii Wileńskiej',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_46.jpg"
      },
      {
        id: 11,
        title: '',
        text: 'Uroczystości w Kalwarii Wileńskiej',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_47.jpg"
      },
      {
        id: 12,
        title: '',
        text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_48.jpg"
      },
      {
        id: 13,
        title: '',
        text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_49.jpg"
      },
      {
        id: 14,
        title: '',
        text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_50.jpg"
      },
      {
        id: 15,
        title: '',
        text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_51.jpg"
      },
      {
        id: 16,
        title: '',
        text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_52.jpg"
      },
      {
        id: 17,
        title: '',
        text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_53.jpg"
      },
      {
        id: 18,
        title: '',
        text: 'Msza Św. w drewnianym kościółku w Kolonii Wileńskiej z 1935 r.',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_54.jpg"
      }
    ],
    lip8:[
      {
        id: 0,
        title: '',
        text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_55.jpg"
      },
      {
        id: 1,
        title: '',
        text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_56.jpg"
      },
      {
        id: 2,
        title: '',
        text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_57.jpg"
      },
      {
        id: 3,
        title: '',
        text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_58.jpg"
      },
      {
        id: 4,
        title: '',
        text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_59.jpg"
      },
      {
        id: 5,
        title: '',
        text: 'Uroczystość w Ponarach – miejscu masowej zagłady ofiar reżimu nazistowskiego',
        img: "/aktualnosci/relacja_z_obchodow/relacja_z_obchodow_60.jpg"
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/models/aktualnosci/relacja_z_obchodow.js